import Dexie from 'dexie';

function getChinaDB() {
	const db = new Dexie("dict");
	db.version(1).stores({
		master: "&key, value",
		chinaDict: "&chn_text, pinyin, means, time"
	});

	db.version(2).stores({
		master: "&key, value",
		chinaDict: null
	});

	db.version(3).stores({
		master: "&key, value",
		chinaDict: "&entryid, chn_text, pinyin, means, time, pronounce_chn_text, prop, _id"
	}).upgrade(async function(tx) {
		await db.master.put({
			key : "china_last_time",
			value : 0
		});
	});

	db.version(4).stores({
		master: "&key, value",
		chinaDict: "&entryid, chn_text, pinyin, means, time, pronounce_chn_text, prop, _id",
		memorizeDict: "&entryid, chn_text, pinyin, means, time, pronounce_chn_text, prop, _id"
	}).upgrade(async function(tx) {
		await db.master.put({
			key : "china_last_time",
			value : 0
		});
	});


	return db;
}

function remotePlayer(eventName, e, data) {
	if(e) {
		e.stopPropagation();
		e.preventDefault();
	}

	document.querySelector('#playerArea > iframe').contentWindow.postMessage({
		eventName : eventName,
		eventData : data
	}, '*');
}

function getAudioDB() {
	const db = new Dexie("swamp");

	db.version(1).stores({
		__playlist__: "&time, value"
	});

	// return db;
	return {
		select : () => {
			return db.__playlist__.toArray();
		},
		setList : async (items) => {
			await db.__playlist__.clear();
			await db.__playlist__.bulkPut(items);
		},
		insertList : async (items) => {
			await db.__playlist__.bulkPut(items);
		},
		insert : async (item) => {
			await db.__playlist__.put(item);
		},
		deleteItem : async (key) => {
			await db.__playlist__.delete(key);
		},
	}
}

export {
	getChinaDB,
	getAudioDB,
	remotePlayer,
};